/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { StepDeliveryEditPageContentStepDeliveryPayloadFragmentDoc } from './StepDeliveryEditPageContent.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type StepDeliveryStepAnswerSelectionInput = {
  guid?: string | number | null | undefined;
  selection: string;
};

export type StepDeliveryStepInput = {
  answerSelections?: Array<StepDeliveryStepAnswerSelectionInput> | null | undefined;
  guid?: string | number | null | undefined;
  message: string;
  targetDayAfter: number;
  targetHour: number;
};

export type UpdateStepDeliveryInput = {
  IsDisabled: boolean;
  addFriendDate?: DateString | null | undefined;
  cond: string;
  endAt?: DateString | null | undefined;
  guid: string | number;
  name: string;
  startAt?: DateString | null | undefined;
  steps: Array<StepDeliveryStepInput>;
};

export type StepDeliveryEditPageQueryVariables = Exact<{
  guid: string | number;
}>;


export type StepDeliveryEditPageQuery = { stepDelivery: { guid: string, name: string, startAt: DateString | null, endAt: DateString | null, cond: string, addFriendDate: DateString | null, IsDisabled: boolean, steps: Array<{ guid: string, stepDeliveryGuid: string, targetDayAfter: number, targetHour: number, message: string, answerSelections: Array<{ guid: string, stepDeliveryStepGuid: string, selection: string }> | null }> } };

export type UpdateStepDeliveryMutationVariables = Exact<{
  input: Types.UpdateStepDeliveryInput;
}>;


export type UpdateStepDeliveryMutation = { updateStepDelivery: { StepDelivery: { __typename: 'StepDelivery' } } };


export const StepDeliveryEditPageDocument = gql`
    query StepDeliveryEditPage($guid: ID!) {
  stepDelivery(guid: $guid) {
    ...StepDeliveryEditPageContentStepDeliveryPayload
  }
}
    ${StepDeliveryEditPageContentStepDeliveryPayloadFragmentDoc}`;

/**
 * __useStepDeliveryEditPageQuery__
 *
 * To run a query within a Vue component, call `useStepDeliveryEditPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useStepDeliveryEditPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useStepDeliveryEditPageQuery({
 *   guid: // value for 'guid'
 * });
 */
export function useStepDeliveryEditPageQuery(variables: StepDeliveryEditPageQueryVariables | VueCompositionApi.Ref<StepDeliveryEditPageQueryVariables> | ReactiveFunction<StepDeliveryEditPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<StepDeliveryEditPageQuery, StepDeliveryEditPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<StepDeliveryEditPageQuery, StepDeliveryEditPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<StepDeliveryEditPageQuery, StepDeliveryEditPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<StepDeliveryEditPageQuery, StepDeliveryEditPageQueryVariables>(StepDeliveryEditPageDocument, variables, options);
}
export function useStepDeliveryEditPageLazyQuery(variables?: StepDeliveryEditPageQueryVariables | VueCompositionApi.Ref<StepDeliveryEditPageQueryVariables> | ReactiveFunction<StepDeliveryEditPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<StepDeliveryEditPageQuery, StepDeliveryEditPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<StepDeliveryEditPageQuery, StepDeliveryEditPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<StepDeliveryEditPageQuery, StepDeliveryEditPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<StepDeliveryEditPageQuery, StepDeliveryEditPageQueryVariables>(StepDeliveryEditPageDocument, variables, options);
}
export type StepDeliveryEditPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<StepDeliveryEditPageQuery, StepDeliveryEditPageQueryVariables>;
export const UpdateStepDeliveryDocument = gql`
    mutation UpdateStepDelivery($input: UpdateStepDeliveryInput!) {
  updateStepDelivery(input: $input) {
    StepDelivery {
      __typename
    }
  }
}
    `;

/**
 * __useUpdateStepDeliveryMutation__
 *
 * To run a mutation, you first call `useUpdateStepDeliveryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStepDeliveryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateStepDeliveryMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStepDeliveryMutation(options: VueApolloComposable.UseMutationOptions<UpdateStepDeliveryMutation, UpdateStepDeliveryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateStepDeliveryMutation, UpdateStepDeliveryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateStepDeliveryMutation, UpdateStepDeliveryMutationVariables>(UpdateStepDeliveryDocument, options);
}
export type UpdateStepDeliveryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateStepDeliveryMutation, UpdateStepDeliveryMutationVariables>;